import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { InadimplenciaHistoricalOverview } from '@/features/inadimplencia/types/InadimplenciaHistoricalOverview.ts';

async function getTermometroFrequenciaMetricasAlunos(params): Promise<InadimplenciaHistoricalOverview> {
  const api = await getApi();
  const { data } = await api.get<InadimplenciaHistoricalOverview>('termometro/frequencia/metricas_alunos', {params});
  return data;
}

type QueryFnType = typeof getTermometroFrequenciaMetricasAlunos;

function useTermometroFrequenciaMetricasAlunos(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-termometro-financeiro-metrica-alunos',  params],
    queryFn: () =>  getTermometroFrequenciaMetricasAlunos(params),
  });
}

export { useTermometroFrequenciaMetricasAlunos };
